import { lazy } from "react";
import componentLoader from "./componentLoader.js";

const lazyComponentLoader = (lazyComponent, description = "") =>
  lazy(() => componentLoader(lazyComponent, description));

export default lazyComponentLoader;
